import get from "lodash/get";
import { getParameterByName } from "../../utils";
import { matchesTCode } from "../utils/helpers";
const log = console;

const enviar = (context, queryParams) => {
  const tipoPaquete = get(
    context,
    "state.paquetesBeneficios.caracteristicas.tipoPaquete",
    ""
  );
  matchesTCode(["afl-pml", "afl--pml"], function() {
    const clickID = getParameterByName("clickid");
    if (tipoPaquete && clickID) {
      try {
        const orderID = get(context, "state.dataOferta.nroDeTramite", "");
        const nroCliente = get(
          context,
          "state.dataOferta.oferta.numeroCliente",
          ""
        );

        // PML postback
        const pmlurl = new URL(`https://www.w4gb0ubgf.com/?nid=3280`);
        pmlurl.searchParams.append("adv1", orderID);
        pmlurl.searchParams.append("adv2", nroCliente);
        pmlurl.searchParams.append("transaction_id", clickID);
        if (queryParams !== undefined) {
          Object.keys(queryParams).forEach(key => {
            pmlurl.searchParams.append(key, queryParams[key]);
          });
        }

        fetch(pmlurl.href, {
          method: "GET"
        })
          .then(r => log.log("PML | Success:", r))
          .catch(r => log.error("PML | Error:", r));
      } catch (error) {
        log.error("PML | Error:", error);
      }
    }
  });
};

export const PML = {
  enabled: true,
  enable() {},
  init() {},

  /**
   * Oferta Nomina
   */

  /**
   * Pasos del Camino 2 - Paquetes
   */
  enviar(context) {
    enviar(context);
  },
  enviarOfertaPq(context) {
    enviar(context, {
      event_id: 25
    });
  }
};
